import React, { useEffect, useState } from "react";
import QuestionType from "./QuestionType";
import InspectionImagePopOver from "./InspectionImagePopOver";
import { useLanguageContext } from "../../../Context/LanguageContext";
import { _functionHelper } from "../HelperFunction/HelperFunction";

export default function QuestionIndex({
  handleChangeField,
  questionList,
  showCanCreateTicketCheckbox,
}) {
  const { language, localization } = useLanguageContext();
  const [questionRender, setQuestionRender] = useState(null);

  const [imageList, setImageList] = useState({
    imageList: null,
    questionNo: null,
  });
  const handleFieldChange = (
    _value,

    _questionNo
  ) => {
    const _tempValue = [...questionRender["questionListWithValue"]];

    const question = _tempValue[_questionNo];
    const isMandatory = question.isMandatory;
    const valueIsNotEmpty = _value !== "";
    const isTextOrObjectiveOrNumberOrDescriptive = _functionHelper.isQueType(
      question.answerType
    );
    if (isTextOrObjectiveOrNumberOrDescriptive) {
      question.value.first = _value;
      if (isMandatory) {
        question.error = !valueIsNotEmpty;
        question.errorMessage.first = valueIsNotEmpty
          ? ""
          : localization.fieldRequired;
      }
    } else {
      question.value = _value;
      if (isMandatory) {
        question.error = !valueIsNotEmpty;
        question.errorMessage = valueIsNotEmpty
          ? ""
          : localization.fieldRequired;
      }
    }
    if (question.canCreateTicket && question.createTicket) {
      if (question.answerType.toLowerCase() == "rangevalue") {
        if (
          parseFloat(_value.toLowerCase().trim()) >=
            parseFloat(question.rangeValue["min"]) ||
          parseFloat(_value.toLowerCase().trim()) <=
            parseFloat(question.rangeValue["max"])
        ) {
          question.createTicket = false;
        }
      } else if (
        _value.trim().toLowerCase() == question["antwort"].trim().toLowerCase()
      ) {
        question.createTicket = false;
      }
    }
    handleChangeField(_tempValue);
  };

  const handleBlur = (isError, _value, isSecondEmpty, _questionNo) => {
    const _tempValue = [...questionRender["questionListWithValue"]];
    const _trackQuestion = _tempValue[_questionNo];
    const isContainArrayValue = _functionHelper.isQueType(
      _trackQuestion.answerType
    );

    if (isError) {
      if (isContainArrayValue) {
        _tempValue[_questionNo].error = true;
        _tempValue[_questionNo].errorMessage["first"] =
          localization.fieldRequired;
        _tempValue[_questionNo].errorMessage["second"] = isSecondEmpty
          ? localization.selectoptionDropDown
          : "";
      } else {
        _tempValue[_questionNo].error = true;
        _tempValue[_questionNo].errorMessage = localization.fieldRequired;
      }

      handleChangeField(_tempValue);
    }
  };
  const handleButtonClick = (questionNo, _value) => {
    const _tempValue = [...questionRender["questionListWithValue"]];
    _tempValue[questionNo]["value"]["second"] = _value;
    _tempValue[questionNo]["errorMessage"]["second"] =
      _value === "" ? localization.selectoptionDropDown : "";
    handleChangeField(_tempValue);
  };

  const fileHandler = (questionNo, _value) => {
    const _tempValue = [...questionRender["questionListWithValue"]];
    _tempValue[questionNo]["value"] = _value;
    _tempValue[questionNo]["error"] = _value !== "" ? false : true;
    _tempValue[questionNo]["errorMessage"] =
      _value !== "" ? localization.addImage : "";
    handleChangeField(_tempValue);
  };

  const handleQuestionImageChange = (questionNo, imageData) => {
    const _tempValue = [...questionRender["questionListWithValue"]];
    _tempValue[questionNo]["questionImage"] = imageData;
    handleChangeField(_tempValue);
  };

  useEffect(() => {
    if (questionList) {
      setQuestionRender({
        questionListWithValue: questionList.questions["pruefFragenItemModels"],
        blockId: questionList.questions["id"],
      });
    } else if (questionRender) {
      setQuestionRender(null);
    }
  }, [questionList]);

  useEffect(() => {
    if (questionRender) {
      let isChanged = false;
      const _tempValue = [...questionRender["questionListWithValue"]];
      _tempValue.forEach((item) => {
        if (item[["error"]]) {
          isChanged = true;
          if (_functionHelper.isQueType(item.answerType)) {
            item["errorMessage"]["first"] = localization.fieldRequired;
          } else {
            item["errorMessage"] = localization.fieldRequired;
          }
        }
      });
      if (isChanged) {
        setQuestionRender((prev) => ({
          ...prev,
          questionListWithValue: _tempValue,
        }));
      }
    }
  }, [language]);
  function handleImagePopover(_value, questionNo) {
    if (_value) {
      setImageList((pre) => ({
        imageList: questionRender["questionListWithValue"][questionNo].value,
        questionNo: questionNo,
      }));
    } else {
      setImageList({
        imageList: null,
        questionNo: null,
      });
    }
  }

  function handleImageDel(_index) {
    const _tempImageList = questionRender["questionListWithValue"][
      imageList.questionNo
    ].value.filter((item, index) => index !== _index);
    setImageList((prev) => ({
      ...prev,
      imageList: _tempImageList,
    }));
    const _tempValue = [...questionRender["questionListWithValue"]];
    _tempValue[imageList.questionNo]["value"] =
      _tempImageList.length > 0 ? _tempImageList : "";
    handleChangeField(_tempValue);
  }
  return (
    <div className="mt-5">
      {questionRender &&
        questionRender["questionListWithValue"]?.map((item, index) => (
          <QuestionType
            key={index}
            question={item}
            questionNo={index + 1}
            _key={item.ID + index}
            onFieldChange={handleFieldChange}
            handleBlurChanges={handleBlur}
            isDisable={false}
            handleButtonStatusChange={handleButtonClick}
            fileHandler={fileHandler}
            handleImagePopover={handleImagePopover}
            handleCreateTicketCheckbox={() => {}}
            showCanCreateTicketCheckbox={showCanCreateTicketCheckbox}
            handleQuestionImageChange={handleQuestionImageChange}
          />
        ))}
      {imageList.imageList && (
        <InspectionImagePopOver
          handleImagePopover={handleImagePopover}
          imageList={imageList.imageList}
          handleImageDel={handleImageDel}
        />
      )}
    </div>
  );
}
